// extracted by mini-css-extract-plugin
export var contactContainer = "burger-menu-module--contactContainer--c976a";
export var cross = "burger-menu-module--cross--9af8c";
export var crossButton = "burger-menu-module--crossButton--c0c11";
export var header = "burger-menu-module--header--1752a";
export var headerCollapsed = "burger-menu-module--headerCollapsed--9bf8f";
export var headerContent = "burger-menu-module--headerContent--e7667";
export var icon = "burger-menu-module--icon--dab56";
export var iconCircle = "burger-menu-module--iconCircle--aadb6";
export var iconContainer = "burger-menu-module--iconContainer--74b7d";
export var lang = "burger-menu-module--lang--52777";
export var langSelector = "burger-menu-module--langSelector--3d95e";
export var link = "burger-menu-module--link--7fc12";
export var linkElement = "burger-menu-module--linkElement--47a82";
export var linkElementAnchor = "burger-menu-module--linkElementAnchor--66add";
export var linkElementCollapsed = "burger-menu-module--linkElementCollapsed--8d153";
export var linkSeparator = "burger-menu-module--linkSeparator--410b9";
export var linksContainer = "burger-menu-module--linksContainer--10646";
export var logo = "burger-menu-module--logo--1463d";
export var logoContainer = "burger-menu-module--logoContainer--b6487";
export var logoLink = "burger-menu-module--logoLink--c74a6";
export var menuArrow = "burger-menu-module--menuArrow--0e820";
export var menuButton = "burger-menu-module--menuButton--51c78";
export var menuContainer = "burger-menu-module--menuContainer--46c3d";
export var menuContent = "burger-menu-module--menuContent--0d5b6";
export var searchBarContainer = "burger-menu-module--searchBarContainer--f1e63";
export var searchModuleContent = "burger-menu-module--searchModuleContent--66eab";
export var sideButton = "burger-menu-module--sideButton--fa72a";
export var sideLink = "burger-menu-module--sideLink--4270d";
export var slideIn = "burger-menu-module--slideIn--c159b";
export var slideOut = "burger-menu-module--slideOut--23cc4";